import React, {Component} from 'react';
import PaymentAndUsageHistoryDateRangePicker from './PaymentAndUsageHistoryDateRangePicker';
import {Route} from 'react-router-dom';
import PaymentHistoryList from './PaymentHistoryList';
import ProductBillingHistoryList from './ProductBillingHistoryList';
import {PageSubTitle, PageTabs} from '../../../Common/PageComponents';

class PaymentAndUsageHistory extends Component {
  render() {
    return (
      <div>
        <PageSubTitle title="사용내역 조회" />
        <PaymentAndUsageHistoryDateRangePicker />
        <PageTabs
          data={[
            {
              key: 'payment-history',
              link: '/my-pc-bang/usage-status/payment-and-billing/payment-history?scrolltop=false',
              name: '결제내역',
            },
            {
              key: 'billing-history',
              link: '/my-pc-bang/usage-status/payment-and-billing/billing-history?scrolltop=false',
              name: '사용내역',
            },
          ]}
          pickedMenu={this.props.match.params.category}
        />
        <Route path="/my-pc-bang/usage-status/payment-and-billing/payment-history" component={PaymentHistoryList} />
        <Route
          path="/my-pc-bang/usage-status/payment-and-billing/billing-history"
          component={ProductBillingHistoryList}
        />
      </div>
    );
  }
}

export default PaymentAndUsageHistory;
